export default __webpack_public_path__ + "media/facebook.2e18b74a.svg";